import type { DrugFilter } from '@/entities/drug/api/drug.api';

/** M-11 필터 값 — URL search params(tradable · filters · pharma)와 1:1 */
export interface DrugFilterValue {
  tradable: boolean;
  filters: DrugFilter[];
  pharma: number[];
}

export const EMPTY_FILTER: DrugFilterValue = {
  tradable: false,
  filters: [],
  pharma: [],
};

/** 고른 필터 수 (모바일 [필터 n] 버튼) */
export const countFilters = (f: DrugFilterValue) =>
  (f.tradable ? 1 : 0) + f.filters.length + f.pharma.length;
